import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationExtras, Router, RouterOutlet } from '@angular/router';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { ExcelExportEvent, KENDO_GRID, KENDO_GRID_EXCEL_EXPORT } from '@progress/kendo-angular-grid';
import { KENDO_SVGICON } from '@progress/kendo-angular-icons';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { KENDO_BREADCRUMB } from '@progress/kendo-angular-navigation';
import { cloudIcon, fileExcelIcon } from '@progress/kendo-svg-icons';
import { ObjectsI, ProjectsI } from '../../_models/projects';
import { ProjectsService } from '../../_services/projects.service';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DropDownListModule, DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { formatDate } from '../../globals';
import { SubjectService } from '../../_services/subject.service';

import { combineLatest, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators'


@Component({
    selector: 'app-purchase-orders',
    imports: [KENDO_SVGICON, KENDO_BUTTON, KENDO_GRID, KENDO_BREADCRUMB, KENDO_GRID_EXCEL_EXPORT,
        LayoutModule, CommonModule, DropDownsModule, DropDownListModule, ReactiveFormsModule, InputsModule],
    templateUrl: './purchase-orders.component.html',
    styleUrl: './purchase-orders.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class PurchaseOrdersComponent implements OnInit, OnDestroy {
  projects: ProjectsI[] = [];
  filteredProjects: ProjectsI[] = [];
  selection: any[] = [];
  svgIcon = [cloudIcon, fileExcelIcon];
  form!: FormGroup;
  portalObjects: ObjectsI[] = [];
  data = [];
  width = '300';
  loading = false;
  loading1 = false;
  copyPurchaseOrders: ObjectsI[] = [];
  private destroy$ = new Subject<void>();
  constructor(private service: ProjectsService, private cdr: ChangeDetectorRef,
    private router: Router, private fb: FormBuilder, private sub: SubjectService) {
    this.form = this.fb.group({
      project: {
        projectname: "Select a Project..",
        projectId: null
      },
      purchaseOrder: {
        name: "Select an Order No..",
        id: null
      }
    });
    this.getProjectsList();
    const currentNavigation = this.router.getCurrentNavigation();
    if (currentNavigation?.extras.state) {
      const url = currentNavigation.extras.state['url'];
      this.data = url?.split('/');
      this.form.patchValue({
        project: {
          projectname: this.data[1],
          projectId: this.data[0]
        }
      });
    }
    if (this.form.value.project.projectId) {
      sessionStorage.setItem('projectId', JSON.stringify(this.form.value.project.projectId));
      sessionStorage.setItem('projectName', JSON.stringify(this.form.value.project.projectname));
      this.form.get('purchaseOrder')?.enable();
      this.getPOGrid();
    } else {
      // this.form.get('purchaseOrder')?.disable();
      if (sessionStorage.getItem('projectId')) {
        let name = JSON.parse(sessionStorage.getItem('projectName') || '');
        let id = JSON.parse(sessionStorage.getItem('projectId') || '');
        this.form.get('purchaseOrder')?.enable();
        this.form.patchValue({
          project: {
            projectname: name,
            projectId: id
          }
        });
        this.getPOGrid();
      }
    }
  }
  ngOnInit(): void {
    this.sub.refreshTrigger$
      .pipe(
        takeUntil(this.destroy$),
        filter(trigger => trigger === 'orders')
      )
      .subscribe(() => {
        this.getProjectsList();
        this.getPOGrid();
        this.cdr.markForCheck();
      });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  getPOGrid() {
    if (this.form.value.project.projectId) {
      this.loading1 = true;
      this.service.purchaseOrders(this.form.value.project.projectId).subscribe({
        next: (result) => {
          this.portalObjects = result;
          this.copyPurchaseOrders = this.portalObjects;
          this.cdr.markForCheck();
        },
        error: (error) => {
          //throw message of some sort
          console.log(error)
        },
        complete: () => {
          this.loading1 = false;
        }
      });
    }

  }
  getProjectsList() {
    this.loading = true;
    this.service.getProjects().subscribe(res => {
      this.projects = res;
      this.filteredProjects = this.projects;
      this.loading = false;
      this.cdr.markForCheck();
    });
  }

  public rowCallback = (context: any) => {
    return {
      'hide-row': context.dataItem.totalpocount == 0
    };
  };
  getObjectsForProjects(event: any) {
    this.loading = true;
    if (this.form.value.project.projectId) {
      sessionStorage.setItem('projectId', JSON.stringify(this.form.value.project.projectId));
      sessionStorage.setItem('projectName', JSON.stringify(this.form.value.project.projectname));
      this.service.purchaseOrders(+event?.projectId).subscribe({
        next: (result) => {
          this.portalObjects = result;
          this.copyPurchaseOrders = this.portalObjects;
          this.loading = false;
          this.cdr.markForCheck();
        },
        error: (error) => {
          //throw message of some sort
          console.log(error)
        },
        complete: () => {
          /* for (var i = 0; i < this.portalObjects.length; i++) {
            if (this.portalObjects[i].maxuploaddate != null) {
              this.portalObjects[i].maxuploaddate = this.convertDate(this.portalObjects[i].maxuploaddate);
              this.copyPurchaseOrders[i].maxuploaddate = this.convertDate(this.portalObjects[i].maxuploaddate);
            }
          } */
        }

      });
    }

  }

  convertDate(value: Date): Date {
    const dateValue = new Date(value);

    const timezoneOffset = dateValue.getTimezoneOffset(); // Offset in minutes

    const localDate = new Date(dateValue.getTime() + timezoneOffset * 60 * 1000);

    return localDate;
  }

  public onFilter(value: string): void {
    const scalingFactor = 7; // This value depends on the font size and family
    const characterCount = value.length;
    const newWidth = Math.max(50, characterCount * scalingFactor);
    if (+this.width < 400) {
      if (newWidth - 100 > 0 && newWidth - 100 < 500) {
        this.width = (newWidth + 200).toString();
      }
    }
    if (value.length) {
      this.portalObjects = this.copyPurchaseOrders.filter(obj => obj.description.toLowerCase().includes(value.toLowerCase()) || obj.companyName.toLowerCase().includes(value.toLowerCase()) || obj.name.toLowerCase().includes(value.toLowerCase()));
    } else {
      this.portalObjects = this.copyPurchaseOrders;
      this.width = '300';
    }
  }
  navigate(str: string, count: number, dataItem?: any) {
    // if (count > 0) {
    const navigationExtras: NavigationExtras = {
      state: {
        url: `${dataItem.projectId}/${dataItem.id}/${dataItem.projectName}/${dataItem.name}/${str}/${dataItem.companyName}/${dataItem.description}`
      }
    };
    if (str == 'pending-acknowledgement') {
      this.router.navigate(['/submittals'], navigationExtras);
    }
    if (str == 'submittals') {
      this.router.navigate(['/submittals'], navigationExtras);
    }
    if (str == 'drafts') {
      // && ['ADMIN', 'UPLOAD'].includes(dataItem.accessType)
      const navigationExtras: NavigationExtras = {
        state: {
          url: `${dataItem.projectId}/${dataItem.id}/${dataItem.projectName}/${dataItem.name}/${dataItem.accessType}/${dataItem.companyName}`
        }
      };
      this.router.navigate(['/drafts'], navigationExtras);
    }
    // }
  }
  getCount(uploadcount: number, filecount: number) {
    return filecount > 0 ? `${uploadcount} & ${filecount}` : uploadcount
  }
  getFileName() {
    let str = 'Orders Overview';
    return `${str} ${this.getFormattedDate()}.xlsx`
  }
  getFormattedDate(): string {
    const date = new Date();
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  onExcelExport(e: ExcelExportEvent): void {
    const sheet = e.workbook.sheets[0];
    const header = sheet.rows[0];
    const getIndex = (field: string) => header.cells.findIndex((c: any) => c?.value === field);
    const projectId = this.form.value.project.projectId;
    const projectName = this.form.value.project.projectname;
    const background = header.cells[0]?.background;
    const color = header.cells[0]?.color;

    //const uploadCount = getIndex('All Submittals & Files');
    const dateCount = getIndex('Last Submittal Date');

    this.portalObjects.forEach((item, i) => {
      const row = sheet.rows[i + 1];
      if (!row || row.type !== 'data') return;

      //row.cells[uploadCount].value = this.getCount(item.uploadcount, item.filecount);
      row.cells[dateCount].value = item.maxuploaddate ? formatDate(item.maxuploaddate) : null;

      row.cells.unshift(
        { value: projectId },
        { value: projectName }
      );
    });

    header.cells.unshift(
      { value: 'Project ID', background, color },
      { value: 'Project Name', background, color }
    )
  }

  onProjectFilter(value: string): void {
    console.log("this.filteredProjects", this.filteredProjects, value)
    this.filteredProjects = this.projects.filter(p =>
      p.projectname && p.projectname.toLowerCase().includes(value.toLowerCase())
    );
  }
}
